module.exports = __webpack_public_path__ + "static/media/back-desktop.29bf9dc7.svg";